import arrowIconPng from './arrowIcon.png';

export const arrowIconSources = [arrowIconPng];
